import createSvgIcon from '../Utils/CreateSvgIcon';

export const Mileage = createSvgIcon(
  <path d="M5.60944 10.1867C6.88021 8.50216 8.8016 7.33603 11 7.06189V9H13V7.06189C15.1984 7.33603 17.1198 8.50216 18.3906 10.1867L16.5528 11.1056L17.4472 12.8944L19.3874 11.9243C19.7821 12.8712 20 13.9101 20 15L20 17H15V19H21H22L22 18V15C22 9.47715 17.5228 5 12 5C6.47715 5 2 9.47715 2 15V18V19L3 19H12H13.618L12.8944 17.5528L10.8944 13.5528L9.10557 14.4472L10.382 17H4V15C4 13.9101 4.21793 12.8712 4.6126 11.9243L6.55279 12.8944L7.44721 11.1056L5.60944 10.1867Z" />,
  'Mileage',
);
